import { useEffect, useState } from 'react';
import './UnityModelLoading.less';
import UploadProgress from '../UploadProgress/UploadProgress';
export default function UnityModelLoading(props) {
  useEffect(() => {}, []);
  return (
    <div className="unity-model-loading">
      {/* <div className="unity-model-loading-icon"></div> */}
      <UploadProgress percent={props.loadingProgression} gifLoading={true}></UploadProgress>
    </div>
  );
}
